import Category from '../../compounds/category'
import Breadcrumb from '../../compounds/breadcrumb'
import { useEntity } from '@uswitch/ev-utils/context/selectors'

const Figure = props => {
  const Breadcrumbs = props.breadcrumbs && <Breadcrumb entity={props.breadcrumbs} />

  return <Category {...props} breadcrumbs={Breadcrumbs} />
}

const FigureConnected = props => {
  const imageEntity = useEntity(props.image)
  return <Figure {...props} image={imageEntity} />
}

export default FigureConnected
